

import gql from "graphql-tag"

export const UserInfoGQL = gql`
    query userInfoQuery {
    getUserInfo {
        email
        name
        companyId
    }
    }
`
